import {Component, OnInit} from '@angular/core';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {TimerangePanelComponent} from '../timerange-panel.component';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {ParamonModel} from '../../../../../projects/api/src/paramon/paramon.model';
import {TimerangeModel} from '../../../../../projects/api/src/timerange/timerange.model';
import {forkJoin, Observable} from 'rxjs';
import {TimerangeApiService} from '../../../../../projects/api/src/timerange/timerange-api.service';
import {TimerangesApiService} from '../../../../../projects/api/src/timerange/timeranges-api.service';
import {SpinnerComponent} from '../../../shared/spinner/spinner.component';
import {tap} from 'rxjs/operators';
import {InsparkUIModule} from '../../../inspark.module';

@Component({
  selector: 'sem-compose-timerange-panel-modal',
  templateUrl: './compose-timerange-panel-modal.component.html',
  styleUrls: ['./compose-timerange-panel-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    TimerangePanelComponent,
    InsparkUIModule,
    SpinnerComponent
  ],
  providers: [
    TimerangeApiService,
    TimerangesApiService,
    TranslateService
  ]
})
export class ComposeTimerangePanelModalComponent implements OnInit {

  public editableData: ParamonModel;
  public timeranges$: Observable<TimerangeModel[]>;
  public timeranges: TimerangeModel[] = [];
  public readonly = false;

  constructor(public ref: DynamicDialogRef,
              public config: DynamicDialogConfig,
              private timerangeApi: TimerangeApiService,
              private timerangesApi: TimerangesApiService,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.editableData = JSON.parse(JSON.stringify(this.config.data.editableData));
    this.timeranges$ = this.timerangesApi.getAll(this.editableData.id).pipe(tap(data => {
      this.timeranges = data;
    }));
    try {
      this.readonly = this.config.data.editableData.template.id !== this.config.data.templateData.id;
    } catch (e) {
      console.error(e);
      this.readonly = false;
    }
  }

  next() {
    const request: Observable<TimerangeModel>[] = [];
    let isDelete = false;
    this.timeranges.forEach(tr => {
      if (tr.id) {
        if (tr.valueOff === '' || tr.valueOn === '') {
          request.push(this.timerangeApi.delete(tr));
          isDelete = true;
        } else {
          request.push(this.timerangeApi.save(tr));
        }
      } else {
        request.push(this.timerangeApi.create(tr));
      }
    });
    if (isDelete) {
      alert(this.translate.instant('ValueOn and ValueOff will be clear'));
    }
    forkJoin(request).subscribe(data => {
      this.ref.close({saved: true});
    });

  }

  closeModal() {
    this.ref.close(null);
  }

}
